import { render, staticRenderFns } from "./AccountTypeEntry.vue?vue&type=template&id=da20b394"
import script from "./AccountTypeEntry.vue?vue&type=script&lang=js"
export * from "./AccountTypeEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports